<i18n>
{
	"en": {
		"QuickSelect": "Quick Select reason"
	},
	"vi": {
		"QuickSelect": "Chọn nhanh lý do"
	}
}
</i18n>
<template>
	<div class="cbs-quick-reason">
		<div class="mt-6 time-repeater--select-byhour  time-repeater--select-days-week">
			<h6 class="mb-2 custom-component--title">{{ $t("QuickSelect") }}:</h6>
			<div class="time-repeater--select-days-week flex justify-start flex-wrap">
				<vs-checkbox v-model="selectedReason" v-for="(item, idx) in listReason" :vs-value="item" :key="idx" class="m-2">
					{{ item }}
				</vs-checkbox>
			</div>
		</div>
	</div>
</template>

<script>
import * as _ from "lodash";
export default {
	name: "CbsQuickReason",
	props: {
		value: {
			type: String,
			required: true
		},
		positive: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			selectedReason: []
		};
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		listReason() {
			let _listReason = ["Nội dung không đầy đủ", "Cần bổ sung thông tin", "Thông tin sai"];
			if (this.positive) {
				_listReason = ["Nội dung chi tiết, đầy đủ", "Công việc hoàn thành xuất sắc", "Báo cáo tốt"];
			}
			return _listReason;
		}
	},
	watch: {
		selectedReason() {
			this.localValue = _.toString(this.selectedReason);
		}
	}
};
</script>

<style lang="scss">
.cbs-quick-reason {
	.time-repeater--select-days-week .con-vs-checkbox {
		width: max-content;
		.vs-checkbox {
			transform: rotate(0);
			padding: 5px;
			border-radius: 28px !important;
		}
		.vs-checkbox-primary input:checked + .vs-checkbox {
			border-radius: 28px !important;
		}
		.con-slot-label {
			padding: 5px;
		}
	}
}
</style>
